import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ size: number }>()((_, { size }) => {
  return {
    root: {
      position: 'relative',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
    },

    container: {
      height: size,
      width: size,

      '& img, video': {
        width: '100%',
        height: '100%',
      },
    },
  };
});
